<div class="product-notification-modal-container">
  <header class="product-notification-modal-header">
    <zbp-icon [iconName]="iconNames.info_circle"></zbp-icon>
    <h3 class="product-notification-modal-title">{{title}}</h3>
  </header>
  <section class="product-notification-modal-content">
    <p class="product-notification-modal-p">Your administrator <span class="product-notification-admin-name">{{firstName}} {{lastName}}</span> made edits to {{whereChangesWereMade}} at 
      <span class="product-notification-modal-change-time">{{dateForDisplay}} &#64; {{timeForDisplay}}</span></p>
  </section>
  <footer>
    <zbp-button-component
      type="button"
      class="text-uppercase product-notification-modal-confirm"
      label="Confirm"
      theme="primary"
      (clickHandler)="confirm()"
    >
  </zbp-button-component>
  </footer>
</div>
